<div id="forgot-password-page">
  <app-minimalist-entry>
    <a slot="link"  [routerLink]="['/login']">

    </a>
    <div slot="content">
       <span class="login-message" i18n="account active successfully@@accountActiveSuccessfully">
        Your account has been successfully activated. Go to </span>
       <a class="btn btn-info" [routerLink]="['/login']">
        Login
       </a>
    </div>
  </app-minimalist-entry>
</div>
